// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__17Jhl","buttons":"RemoveExpirationActionButtons_buttons__1MdBz"};